import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  private uri = "";// `${environment.apiUrl}`;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
  }

  GetUserReports(reportModuleId: number) {
    console.log('? ', { moduleid: reportModuleId })
    return this.http.post<any>(this.uri + '/Reports/GetUserReports', { moduleid: reportModuleId } );
  }

  CallReport(reportID: number) {
    return this.http.post<any>(this.uri + '/Reports/CallReport', { reportid: reportID } );
  }

  CallReportWithDate(data) {
    return this.http.post<any>(this.uri + '/Reports/CallReport', data );
  }

  CallModules(name: string) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ModulesToReportNames', name: name } );
  }

  DownloadCombinedReports(name: string, estimateid: string) {
    return this.http.post<any>(this.uri + '/DownloadFile/DownloadCombinedReports', { filename: name, id: estimateid } );
  }

  DownloadCombinedReports2(name: string, estimateid: string, ReportCover:boolean) {
    return this.http.post<any>(this.uri + '/DownloadFile/DownloadCombinedReports', { filename: name, id: estimateid, cover:ReportCover ? 1 : 0 } );
  }

  DownloadCombinedReportsCubeBox(data) {
    console.log("🚀 ~ file: reports.service.ts:38 ~ ReportService ~ DownloadCombinedReportsCubeBox ~ data", data)
    return this.http.post<any>(this.uri + '/DownloadFile/DownloadCombinedReportsGeneric', data );
  }

  SaveModules(module: any) {
    module.method = 'Save_ModulesToReportNames'
    return this.http.post<any>(this.uri + '/FlexIntegration', module );
  }

  GenericService(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj );
  }

  formatDate(theDate) {

      var date = theDate;
      var aaaa = date.getFullYear();
      var gg = date.getDate();
      var mm = (date.getMonth() + 1);

      if (gg < 10)
          gg = "0" + gg;

      if (mm < 10)
          mm = "0" + mm;

      var cur_day = aaaa + "-" + mm + "-" + gg;

      var hours = date.getHours()
      var minutes = date.getMinutes()
      var seconds = date.getSeconds();

      if (hours < 10)
          hours = "0" + hours;

      if (minutes < 10)
          minutes = "0" + minutes;

      if (seconds < 10)
          seconds = "0" + seconds;

      return cur_day + " " + hours + ":" + minutes + ":" + seconds;

  }

}
